import React, {FC, PropsWithChildren} from 'react';

import {HandlerOf, Renderer} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {TooltipOverflowCondition} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipOverflowCondition';
import {AnswerFolderModel} from '../../../../models/api/answerFolderModel';
import {AnswerFolderDropdownItemFolderIcon} from './answerFolderDropdownItemFolderIcon';

/*
 * Props.
 */

interface AnswerFolderDropdownItemWrapperProps {
  folder: AnswerFolderModel;
  index: number;
  isChecked: boolean;
  onFolderSelect: HandlerOf<number | undefined>;
  nestingLevel?: number;
  renderTooltip?: Renderer;
}

/*
 * Component.
 */

export const AnswerFolderDropdownItemWrapper: FC<PropsWithChildren<AnswerFolderDropdownItemWrapperProps>> = (
  props,
) => {
  const {folder, index, isChecked, onFolderSelect, nestingLevel, renderTooltip} = props;

  return (
    <DropdownItem
      key={folder.id}
      index={index}
      isChecked={isChecked}
      onSelect={() => onFolderSelect(folder.id)}
      renderTooltip={renderTooltip || (() => folder.name)}
    >
      <AnswerFolderDropdownItemFolderIcon nestingLevel={nestingLevel || 0} />
      <DropdownItemContent isChecked={isChecked}>
        <TooltipOverflowCondition>{props.children}</TooltipOverflowCondition>
      </DropdownItemContent>
    </DropdownItem>
  );
};
